import Vue from 'vue'
import router from './router'
import App from './components/App.vue'

import SmoothScrollbarStyle from 'smooth-scrollbar/dist/smooth-scrollbar.css'
import AOSStyle from 'aos/src/sass/aos.scss'
import LoaderStyle from './Loader.scss'

Vue.config.productionTip = false

const transitions = {
  'transition': 'transitionend',
  'WebkitTransition': 'webkitTransitionEnd',
  'MozTransition': 'transitionend',
  'OTransition': 'otransitionend'
}
const elem = document.createElement('div')

for (var t in transitions) {
  if (typeof elem.style[t] !== 'undefined') {
    window.transitionEnd = transitions[t]
    break
  }
}

window.isIos = /iPad|iPhone|iPod/.test(window.navigator.userAgent) && !window.MSStream

window.isIE = (() => {
  let ua = window.navigator.userAgent
  let msie = ua.indexOf('MSIE ')
  let trident = ua.indexOf('Trident/')
  let edge = ua.indexOf('Edge/')

  if (msie > 0) { // IE 10 or older => return version number
    return !!parseInt(ua.substring(msie + 5, ua.indexOf('.', msie)), 10)
  }

  if (trident > 0) { // IE 11 => return version number
    let rv = ua.indexOf('rv:');
    return !!parseInt(ua.substring(rv + 3, ua.indexOf('.', rv)), 10)
  }

  if (edge > 0) { // Edge (IE 12+) => return version number
    return !!parseInt(ua.substring(edge + 5, ua.indexOf('.', edge)), 10)
  }

  return false
})()

new Vue({
  el: '#app',
  router,
  template: '<App/>',
  components: { App }
})



// WEBPACK FOOTER //
// ./src/main.js